var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "layout" }, [
    _c(
      "div",
      { staticClass: "layout_nav" },
      [_c("Nav", _vm._b({}, "Nav", _vm.getRol, false))],
      1
    ),
    _c(
      "div",
      { staticClass: "layout_center" },
      [
        _c(
          "v-container",
          { attrs: { fluid: "" } },
          [
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  { staticClass: "pa-0" },
                  [_c("Welcome", _vm._b({}, "Welcome", _vm.getUser, false))],
                  1
                ),
                _c(
                  "v-col",
                  { staticClass: "pa-0 py-5", attrs: { md: "auto" } },
                  [
                    _vm._l(_vm.getNotifyDeviceShowAlert, function (item) {
                      return _c(
                        "div",
                        { key: item._id },
                        [
                          _c("NotifyAlert", {
                            attrs: {
                              Item: item,
                              Flag: true,
                              Text: item.register,
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    _c("Snackbar", {
                      attrs: {
                        visible: _vm.getAlert.snackbar,
                        text: _vm.getAlert.text,
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "ctn_indicator" },
                      [
                        _c("Indicator", {
                          attrs: {
                            active: _vm.getPanel.active,
                            inactive: _vm.getPanel.inactive,
                          },
                        }),
                        _c(
                          "div",
                          { staticClass: "ctn_btn_new" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "btn_new",
                                attrs: { color: "primary" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    _vm.takeFlag = true
                                  },
                                },
                              },
                              [
                                _c("v-icon", [_vm._v("mdi-chip")]),
                                _c("span", [_vm._v(" Lectura masiva ")]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("TableComp"),
        _c("p"),
        _c("TakeReadAll", {
          attrs: { visible: _vm.takeFlag },
          on: {
            close: function ($event) {
              _vm.takeFlag = false
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }